<!--
 * @Author: zhengxiaoxiao
 * @Date: 2020-08-14 15:04:51
 * @Description: 首页内部导航
-->
<template>
	<el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect">
		<el-menu-item :index="menu.index" v-for="menu in menuList">{{menu.title}}</el-menu-item>
	</el-menu>
</template>
<script>
export default {
	props: {
		isScroll: Boolean,
	},
	data() {
		return {
			activeIndex: '1',
			menuList: [
				{ title: this.$t('home.services'), index: '1' },
				{ title: this.$t('about.journey'), index: '2' },
				{ title: this.$t('about.team'), index: '3' },
				{ title: this.$t('about.culture'), index: '4' },
				{ title: this.$t('home.information'), index: '5' },
			],
		}
	},
	methods: {
		handleSelect(key) {
			this.$emit('on-select', key)
		},
	},
	watch: {
		isScroll(n) {
			if (n) this.activeIndex = '1'
		},
	},
}
</script>
<style lang="less" scoped>
@import "../../../style/constant.less";
.el-menu {
	border-bottom: none;
	background: none;

	.el-menu-item {
		color: @title-info-color;
		font-size: 16px;
		padding: 0;
		margin: 0 20px;
	}
	.el-menu-item:hover {
		background: none;
		color: @h2-color;
	}
}
@media screen and (min-width: 320px) and (max-width: 480px) {
	.el-menu {
		width: 100%;
		overflow-x: auto;
		display: flex;
		.el-menu-item {
			font-size: 14px;
			padding: 0 5px;
			margin: 0px;
		}
		.el-menu--horizontal>.el-menu-item {
			float:inherit;
		}
	}
}
</style>